import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getCompanyDetails,
  upsertCompanyDetails,
  UpsertCompanyDetailsRequest,
} from '../api/companyDetailsApi';

export const companyDetailsKeys = {
  all: ['organisation', 'company-details'] as const,
};

export function useGetCompanyDetails() {
  return useQuery({
    queryKey: companyDetailsKeys.all,
    queryFn: ({ signal }) => getCompanyDetails(signal),
  });
}

export function useUpsertCompanyDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpsertCompanyDetailsRequest) =>
      upsertCompanyDetails(data),
    onSuccess: data => {
      queryClient.setQueryData(companyDetailsKeys.all, data);
    },
  });
}
